import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import Button from "../../../../components/ui/Button";
import Text from "../../../../components/ui/Text";

export const HowToFindUsDialog = ({ isOpen, onClose, text }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: { sx: { borderRadius: "12px", m: 2, width: "310px" } },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Text variant="pageHeader" sx={{ mb: 0, fontSize: "20px" }}>
          How to find us
        </Text>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Text
          component="p"
          variant="paragraph"
          sx={{ fontSize: "16px", lineHeight: 1.5, mb: 2 }}
        >
          {text}
        </Text>

        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};
